import { FiHome, FiSettings } from "react-icons/fi";
import { IoReceiptOutline } from "react-icons/io5";
import { LiaStoreSolid } from "react-icons/lia";

export const ROUTE_LINK_ITEMS = [
  { name: "Analytics", icon: FiHome, url: "/" },
  { name: "Stores", icon: LiaStoreSolid, url: "/stores" },
  { name: "Payouts", icon: IoReceiptOutline, url: "/payouts" },
  { name: "Settings", icon: FiSettings, url: "/settings" },
];

export const TYPE_OF_BUSINESS = {
  freelancer: "Freelancer",
  proprietor: "Proprietor (with GST)",
  pvtltd: "Pvt Ltd",
};

export const APP_NAMES = { codfirm: "Codfirm", ecom360: "Ecom360" };
